import { GlobalStore, IGlobalStore } from "redux-micro-frontend";
import { APP_NAME, STORE_DEBUG } from "./../constants/environment";
import { AuthReducer } from "./reducers/authReducer";

let globalStore: IGlobalStore;

globalStore = GlobalStore.Get(STORE_DEBUG);
globalStore.CreateStore(APP_NAME, AuthReducer);

export default globalStore;
